module.exports = __webpack_public_path__ + "img/p9.b2b2719.png";